var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38313 16.5882H0.249603V5.90608H3.38313V16.5882ZM1.81468 4.44894C0.812897 4.44894 0 3.57037 0 2.50965C0 2.00006 0.191189 1.51134 0.531508 1.151C0.871827 0.790662 1.3334 0.588226 1.81468 0.588226C2.29597 0.588226 2.75754 0.790662 3.09786 1.151C3.43818 1.51134 3.62936 2.00006 3.62936 2.50965C3.62936 3.57037 2.81647 4.44894 1.81468 4.44894ZM15.1077 16.5882H11.981V11.3882C11.981 10.1489 11.9573 8.55966 10.3518 8.55966C8.72262 8.55966 8.47301 9.90608 8.47301 11.2989V16.5882H5.34286V5.90608H8.34821V7.36323H8.39206C8.81032 6.52394 9.83234 5.63823 11.3569 5.63823C14.5276 5.63823 15.1111 7.84894 15.1111 10.7204V16.5882H15.1077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e25d662aea709d833d1bb75570590ba0.svg";
export { ForwardRef as ReactComponent };